import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Loading } from 'spectre-react/dist/cjs';
import { signOut } from "../api";
import {SIGN_IN_PATH} from "../paths";
import {CHANGES_FEED_FETCH_STOP, LOGGED_OUT} from "../store/actions";
import {Redirect} from "react-router-dom";


class SignOutPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            response: null,
        };
    }

    componentDidMount() {
        this.doDeleteSession();
    }

    doDeleteSession = async () => {
        try {
            const response = await signOut();
            this.setState({ isLoading: false, response });

            this.props.changesFeedFetchStop();
            this.props.onLoggedOut(); // clears currentUser
        } catch (error) {
            console.error('Error during sign out:', error);
            this.setState({ isLoading: false });
        }
    };

    render() {
        console.log('signOutPage');

        const {isLoading} = this.state;
        const {currentUser} = this.props;

        if (isLoading) {
            return <Loading large />;
        }

        if (!currentUser) {
            return <Redirect to={SIGN_IN_PATH} />;
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    currentUser: state.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
    onLoggedOut: () => dispatch({type: LOGGED_OUT}),
    changesFeedFetchStop: () => dispatch({type: CHANGES_FEED_FETCH_STOP})
});

export default connect(mapStateToProps, mapDispatchToProps)(SignOutPage);